import {modifyNodeId} from '../assets/js/common'
import Server from './Server'
import htmlToCanvas from 'html2canvas'
import Vue from 'vue'
import getGlobalParams from './changba-global-params'
// let config = require('../config/index')

function html2canvas (dom, data) {
  data = Object.assign({
    allowTaint: true,
    useCORS: true,
    logging: false
  }, data)
  return htmlToCanvas(dom, data)
}

function removeAttr (data) {
  function walkall (data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        if (/^__/g.test(key)) {
          delete data[key]
        }
        if (data.child) {
          data.child.forEach(element => {
            walkall(element)
          })
        }
      }
    }
  }
  walkall(data)
}

function loadJs (url = '') {
  if (!url) return
  if (!loadJs.cache) loadJs.cache = {}
  if (loadJs.cache[url]) return Promise.resolve()
  return new Promise((resolve, reject) => {
    _loadjs(
      url,
      () => {
        loadJs.cache[url] = 'cached'
        resolve()
      },
      () => {
        console.error(`${url} 加载失败`)
        reject(new Error(`${url} 加载失败`))
      }
    )
  })

  function _loadjs (url, fn, fail) {
    var script = document.createElement('script')
    script.src = url
    script.async = true
    script.onload = fn
    script.onerror = fail
    script.crossOrigin = 'anonymous'
    ;(document.body || document.head).appendChild(script)
  }
}

const normalizeComponentId = (id) => id.split(/\//).map((item) => item.replace(/[A-Z]/g, (match, offset) => (offset > 0 ? '-' : '') + match.toLowerCase())).join('-')

function getBaseNode (node) {
  if (!node.id) return
  // useComponent(node.id)
  var info = {
    id: `cb-${normalizeComponentId(node.name)}`,
    type: node.name,
    label: node.label,
    version: node.version,
    // url: node.path,
    visible: true,
    style: {},
    animate: [],
    props: {},
    path: node.path,
    script: ''
  }
  if (node.style) {
    info.style = Object.assign({
      position: 'absolute',
      width: '80px',
      height: '80px',
      left: '0px',
      top: '0px'
    }, node.style)
  }
  var idCache = Object.keys(window.$_nodecomponents || {}).concat([info.id])
  info = modifyNodeId(info, idCache)
  if (info.label) info.label = info.id.replace(node.id, info.label) // 给label添加id
  return info
}

function useComponent (id) {
  Server({
    url: 'component/useone',
    method: 'post', // default
    needLoading: false,
    data: {
      id: id,
    }
  })
    .then(() => true)
    .catch(console.log)
}

function getNumber (style) {
  style = style || '0'
  var arr = style.match(/^[-0-9.]+/)
  if (arr) {
    return arr[0] - 0
  } else {
    return 0
  }
}

function getBlobBydataURI (dataURI, type) {
  var binary = window.atob(dataURI.split(',')[1])
  var array = []
  for (let i = 0, leng = binary.length; i < leng; i++) {
    array.push(binary.charCodeAt(i))
  }
  const blob = new window.Blob([new Uint8Array(array)], {
    type: type
  })
  return blob
}

function readAsDataURL (file, callback) {
  const reader = new window.FileReader()
  reader.readAsDataURL(file)
  reader.onload = function () {
    callback && callback(this.result)
  }
}

var FINGER_PRINT_URL = 'https://res.cdn.changbaimg.com/!/fingerprintjs2/1.8.0/fingerprint2.min.js'
var STORAGE_KEY = 'CHANGBAFP'

function getFingerPrint () {
  if (!getFingerPrint.promise) {
    getFingerPrint.promise = new Promise((resolve) => {
      var fingerPrint = localStorage.getItem(STORAGE_KEY)
      if (fingerPrint) return resolve(fingerPrint)
      loadJs(FINGER_PRINT_URL).then(() => {
        if (!window.Fingerprint2) resolve('unknown')
        window.Fingerprint2 && new window.Fingerprint2().get((res) => {
          localStorage.setItem(STORAGE_KEY, res)
          resolve(res)
        })
      })
    })
  }
  return getFingerPrint.promise
}

const scrollIntoViewIfNeeded = (element, centerIfNeeded = true) => {
  const makeRange = (start, length) => ({
    start,
    length,
    end: start + length
  })

  const coverRange = (inner, outer) => {
    if (centerIfNeeded === false ||
        (outer.start < inner.end && inner.start < outer.end)) {
      return Math.min(
        inner.start, Math.max(outer.start, inner.end - outer.length)
      )
    }

    return (inner.start + inner.end - outer.length) / 2
  }

  const makePoint = (x, y) => ({
    x,
    y,
    translate: (dX, dY) => makePoint(x + dX, y + dY)
  })

  const absolute = (elem, pt) => {
    while (elem) {
      pt = pt.translate(elem.offsetLeft, elem.offsetTop)
      elem = elem.offsetParent
    }

    return pt
  }

  const extent = makePoint(element.offsetWidth, element.offsetHeight)
  let target = absolute(element, makePoint(0, 0))
  let elem = element.parentNode

  while (elem instanceof HTMLElement) {
    // Apply desired scroll amount.
    const origin = absolute(elem, makePoint(elem.clientLeft, elem.clientTop))

    elem.scrollLeft = coverRange(
      makeRange(target.x - origin.x, extent.x),
      makeRange(elem.scrollLeft, elem.clientWidth)
    )
    elem.scrollTop = coverRange(
      makeRange(target.y - origin.y, extent.y),
      makeRange(elem.scrollTop, elem.clientHeight)
    )

    // Determine actual scroll amount by reading back scroll properties.
    target = target.translate(-elem.scrollLeft, -elem.scrollTop)
    elem = elem.parentNode
  }
}

// 递归设置组件属性值
const setNodeValueDeep = (node, key, value) => {
  if (!node) {
    return
  }

  Vue.set(node, key, value)

  if (node?.child?.length) {
    node.child.forEach((item) => {
      setNodeValueDeep(item, key, value)
    })
  }
}


const getQueryStrFn = function(name, url) {
  /* jshint ignore:start */
  name = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
  if (!url) {
    url = window.location.href;
  }
  const _regexS = '[\\?&]' + name + '=([^&#]*)';
  /* jshint ignore:end */
  const _regex = new RegExp(_regexS);
  const _results = _regex.exec(url);

  if (_results == null) {
    return '';
  }
  else {
    return decodeURIComponent(_results[1].replace(/\+/g, ' '));
  }
};

export default {
  html2canvas,
  removeAttr,
  loadJs,
  getBaseNode,
  useComponent,
  getNumber,
  getBlobBydataURI,
  readAsDataURL,
  getFingerPrint,
  scrollIntoViewIfNeeded,
  normalizeComponentId,
  setNodeValueDeep,
  getGlobalParams,
  getQueryStrFn
}

export {
  html2canvas,
  removeAttr,
  loadJs,
  getBaseNode,
  useComponent,
  getNumber,
  getBlobBydataURI,
  readAsDataURL,
  getFingerPrint,
  scrollIntoViewIfNeeded,
  normalizeComponentId,
  setNodeValueDeep,
  getGlobalParams,
  getQueryStrFn
}
